 <!-- 日盘列表 -->
 <template>
    <diV style="background-color: white; height: calc(100vh - 84px); display: flex; flex-direction: column;">
        <el-form class="demo-form-inline" :inline="true" ref="monthleReportForm" :model="monthleReportForm" 
        size="mini" label-width="100px">
            <el-form-item label="仓库" prop="ckName">
                <el-select placeholder="请选择仓库" v-model="monthleReportForm.ckName" clearable>
                    <el-option v-for="item in ckNameList" :key="item" :label="item" :value="item"> </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="">
                <el-button type="primary" @click="getMonthleReportList">搜索</el-button>
                <el-button type="primary" @click="inventoryCountExport">导出</el-button>
            </el-form-item>
        </el-form>
        <div style="flex:1;overflow: hidden" >
            <el-tabs v-model="activeName" @tab-click="handleClick" style="flex: 1;height:100%;">
                <el-tab-pane label="作业数据" name="first" class="tab-pane-full-height">
                    <vxe-table id="dailyReportTable"  size="mini" ref="dailyReportTable" :data="monthleReportList" border stripe
                    header-align="center" :column-config="{resizable: true,sortable: true,drag:true}" height="98%">
                        <vxe-column field="month" title="月份" width="110" ></vxe-column>
                        <vxe-column field="inTons" title="入库（吨）" width="110" ></vxe-column>
                        <vxe-column field="outTons" title="出库（吨）" ></vxe-column>
                        <vxe-column field="totalTons" title="出+入（吨）"  ></vxe-column>
                        <vxe-column field="inCars" title="入库车次"   ></vxe-column>
                        <vxe-column field="outCars" title="出库车次" ></vxe-column>
                        <vxe-column field="ykTons" title="倒库（吨）" ></vxe-column>
                        <vxe-column field="stockTons" title="结存（吨）" ></vxe-column>
                        <vxe-column field="avgStockTons" title="平均结存（吨）"  ></vxe-column>
                    </vxe-table>
                </el-tab-pane>
                <el-tab-pane label="客户统计" name="second" class="tab-pane-full-height">
                    <vxe-table id="customerReportTable"  size="mini" ref="customerReportTable" :data="customerReportList" border stripe
                    header-align="center" :column-config="{resizable: true,sortable: true,drag:true}" height="98%">
                        <vxe-column field="cusName" title="客户名称" width="110" ></vxe-column>
                        <vxe-colgroup :title="item.label" v-for="(item, index) in monthList" :key="index">
                            <vxe-column :field="`col_in_${index}`" title="入库(吨)" width="100" :formatter="({ row }) => getCellValue(row, index, item.label, 'inTons')"></vxe-column>
                            <vxe-column :field="`col_out_${index}`" title="出库(吨)" width="100" :formatter="({ row }) => getCellValue(row, index, item.label, 'outTons')"></vxe-column>
                            <vxe-column :field="`col_stock_${index}`" title="结存(吨)" width="100" :formatter="({ row }) => getCellValue(row, index, item.label, 'stockTons')"></vxe-column>
                            <vxe-column :field="`col_avg_${index}`" title="平均结存(吨)" width="100" :formatter="({ row }) => getCellValue(row, index, item.label, 'avgStockTons')"></vxe-column>
                        </vxe-colgroup>
                    </vxe-table>
                </el-tab-pane>
                <el-tab-pane label="货物大类统计" name="third"  class="tab-pane-full-height">货物大类统计</el-tab-pane>
            </el-tabs>
            
        </div>

    </diV>
</template>
<script>
import ExcelJS from 'exceljs';
import userProfile from '@/mixins/userProfile.js'
import basicData from '@/config/basicData.js'
import AEObasicData from '@/config/AEObasicData.js'
import clean from 'lodash-clean';
import { webapp_ws_ajax_run, webapp_urlprotocol_startup, urlAddRandomNo,webapp_ws_autoupdate, webapp_ws_ajax_together } from "../../utils/reports/grwebapp";

export default {
    name: 'monthleReport',
    mixins: [userProfile],
    components:{

    },
    watch: { 
       
    },
    data() {
        return{
            activeName: 'first', // 默认选中
            monthleReportForm:{
                ckName:"",
            },
            monthleReportList:[],
            ckNameList:[], // 获取仓库列表
            customerReportList:[], // 客户统计
            monthList:[
                {value:'全年',label:'全年'},
                {value:'1',label:'1月'},
                {value:'2',label:'2月'},
                {value:'3',label:'3月'},
                {value:'4',label:'4月'},
                {value:'5',label:'5月'},
                {value:'6',label:'6月'},
                {value:'7',label:'7月'},
                {value:'8',label:'8月'},
                {value:'9',label:'9月'},
                {value:'10',label:'10月'},
                {value:'11',label:'11月'},
                {value:'12',label:'12月'},
                {value:'月均',label:'月均'},
            ]
        }
    },
    async created() {
        await this.getckNameList()
        await this.getMonthleReportList()

    },
    mounted() {

    },
    methods: {
        handleClick(tab, event) {
            if(tab.name == 'first'){
                this.getMonthleReportList()
            }else if (tab.name == 'second'){
                this.wmsGetMonthReportWithCustomer()
            }else if (tab.name == 'third'){

            }

        },
        // 比较数据与列的月份是否相同
        getCellValue(row, index, itemLabel, fieldKey) {
            const cellData = row.contents[0];
            if (!cellData || cellData.month !== itemLabel) return '';
            return cellData[fieldKey] ?? '';
        },
        // 获取数据
        getMonthleReportList() { 
                return this.$api.wmsGetMonthStockTons(this.monthleReportForm.ckName).then(res =>{
                    this.monthleReportList = res
                })
        },
        // 获取客户月报数据
        wmsGetMonthReportWithCustomer(){
            return this.$api.wmsGetMonthReportWithCustomer(  ).then(res =>{
                this.customerReportList = res
            })
        },
        // 获取仓库
        getckNameList(){
            return this.$api.getCkNamesBy(  ).then(res =>{
               this.ckNameList = res
               this.monthleReportForm.ckName = this.ckNameList[0]
            })
        },
        // 导出
        inventoryCountExport(){
            const flatCustomerData = [];
            this.customerReportList.forEach(cus => {
                cus.contents.forEach(monthItem => {
                    flatCustomerData.push({
                        cusName: cus.cusName,
                        inTons: monthItem.inTons,
                        outTons: monthItem.outTons,
                        stockTons: monthItem.stockTons,
                        avgStockTons: monthItem.avgStockTons,
                        month: monthItem.month
                    })
                })
            })
                const params = { 
                    table1:this.monthleReportList,
                    table2:flatCustomerData,
                 }
                var args = {
                    report: urlAddRandomNo("/grf/月报表.grf"),
                    data: params,
                    type: "xls",
                    ExportPageBreak: false, // 导出Excel时是否保留分页符
                    ExportPageHeaderFooter: false, // 导出Excel时是否保留页眉页脚
                    SameAsPrint: false, // 导出Excel时是否与和纸质打印一致
                    showOptionDlg: false, // 是否弹出导出设置弹窗
                };
                webapp_ws_ajax_run(args);
        },
    }
}
</script>
<style lang="less" scoped>
/deep/ .el-tabs__content {
    height: calc(100% - 40px) !important; /* 减去顶部标签栏高度，剩余全部给内容面板 */
    overflow: hidden;
}
/deep/ .tab-pane-full-height {
    width: 100%;
    height: 100%;
}
/* 清空tab-pane默认内边距，避免留白挤压高度 */
/deep/ .el-tab-pane {
    padding: 0 !important;
}
</style>